export const InputType = {
  TEXT: "text",
  AUTO_COMPLETE: "autoComplete"
};

export const SKIN_ANALYSIS_ATTRIBUTES = [
  {
    name: "Sebum",
    dbKey: "sebum",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Pores",
    dbKey: "pores",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Spots",
    dbKey: "spots",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Wrinkles",
    dbKey: "wrinkles",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Acne",
    dbKey: "acne",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Blackheads",
    dbKey: "blackheads",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Dark Circles",
    dbKey: "darkCircles",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Skin Tone",
    dbKey: "skinTone",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Skin Sensitivity",
    dbKey: "skinSensitivity",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "UV Spots",
    dbKey: "uvSpots",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Deep Pigmentation",
    dbKey: "deepPigmentation",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Deep Layer Skin Acne UV",
    dbKey: "deepLayerSkinAcneUV",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Skin Collagen Loss",
    dbKey: "skinCollagenLoss",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  },
  {
    name: "Skin Age",
    dbKey: "skinAge",
    defaultValue: "",
    dropdownValues: [],
    reading: "",
    type: InputType.TEXT
  }
];
